import { render, staticRenderFns } from "./Hall.vue?vue&type=template&id=5dcb8abd&"
import script from "./Hall.vue?vue&type=script&lang=js&"
export * from "./Hall.vue?vue&type=script&lang=js&"
import style0 from "./Hall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports